import { Form } from 'formik';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Accordion, Spinner } from '@treams/treams-ui';

import ListFilterCheckbox from './ListFilterCheckbox';

function LearningFilterSubject() {
	const { localize } = useLocalize();

	const { data } = graphql.useLearningSubjectsQuery({ variables: { first: 1000 } });

	if (!data) {
		return <Spinner centered />;
	}

	return (
		<ListFilterCheckbox
			options={data.learningSubjects.edges.map(({ node }) => ({
				label: localize(node.title)?.text,
				name: 'subjects',
				value: node.id,
			}))}
		/>
	);
}

function LearningFilterType() {
	const { localize } = useLocalize();

	const { data } = graphql.useLearningTypesQuery({ variables: { first: 1000 } });

	if (!data) {
		return <Spinner centered />;
	}

	return (
		<ListFilterCheckbox
			options={data.learningTypes.edges.map(({ node }) => ({
				label: localize(node.title)?.text,
				name: 'types',
				value: node.id,
				tintColor: node.color,
			}))}
		/>
	);
}

const LearningFilterSidebar = () => {
	const { t } = useTranslation();

	return (
		<Form>
			<Accordion
				title={t('learning.events.filters.eventTypes.title')}
				initialIsCollapsed={false}
				small
			>
				<Box px={2}>
					<LearningFilterType />
				</Box>
			</Accordion>

			<Accordion
				title={t('learning.events.filters.subject.title')}
				initialIsCollapsed={isMobile}
				small
			>
				<Box px={2}>
					<LearningFilterSubject />
				</Box>
			</Accordion>
		</Form>
	);
};

export default LearningFilterSidebar;
